import {
  createStyles,
  Grid,
  makeStyles,
  TableBody,
  TableContainer,
  TableHead,
  Tabs,
} from "@material-ui/core";
import React from "react";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import { confirm } from "../../components/ConfirmationDialog/ConfirmationDialog";
import {
  StyledTable,
  StyledTableCellBodyBold,
  StyledTableRow,
} from "../../components/CustomStyles/CustomTable";
import {
  StyledPaperTabs,
  StyledTab,
  StyledTabs,
} from "../../components/CustomStyles/CustomTabs";
import InputSearch from "../../components/InputSearch/InputSearch";
import OrderStore from "../../Store/OrderStore";
import { showQRCodeDialog } from "../Order/parts/QRCodeDialog";
import { ListLoadingOrder, ListOrder } from "./parts/List";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      width: "100%",
    },
    button: {
      margin: 0,
      maxHeight: 30,
      padding: 1,
    },
    paper: {
      padding: 8,
      width: 290,
    },
    demo1: {
      backgroundColor: theme.palette.background.paper,
      marginBottom: 10,
    },
    fab: {
      position: "fixed",
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    card: {
      margin: 5,
      width: "300px",
    },
    cardTitle: {
      color: theme.palette.primary.dark,
      fontWeight: "bolder",
    },
    cardSubHeader: {
      fontSize: "smaller",
    },
  })
);

const Runner = (props) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const access = props.params;
  const classes = useStyles();
  const [tabActive, setTabActive] = React.useState(0);
  const [search, setSearch] = React.useState("");
  const prevTabActive = usePreviousTab(tabActive);
  const [orderState, orderActions] = OrderStore();
  const [status, setStatus] = React.useState("new");

  let arrTabs = [
    {
      status: "new",
      label: "New",
      progress: "process",
      path: "/runner_picked",
      label_action: "Send to PICKUP POINT",
      message_action: "Have you taken items from tenants ?",
      process_action: true,
    },
    {
      status: "complete",
      label: "Complete",
      progress: "process",
      path: "",
      label_action: "Scan for ready to pick up",
      message_action: "Scan for ready to pick up",
      process_action: false,
    },
  ];
  let perPage = 20;

  function usePreviousTab(value) {
    const ref = React.useRef();
    React.useEffect(() => {
      ref.current = value;
    });

    return ref.current;
  }

  const handleChangeTab = (event, newTab) => {
    setTabActive(newTab);
  };

  const handleSearch = async (e) => {
    setSearch(e.target.value);
  };

  const handleUpdateRunner = React.useCallback(
    async (order, action, status) => {
      if (await confirm("", action.message_action, "No", "Yes")) {
        let params = [
          {
            op: "replace",
            path: action.path,
            value: status,
          },
        ];

        orderActions.patch(order.id, params).then(() => {
          handleGetList(true, action.status);
        });
      }
    },
    []
  );

  const handleShowQR = React.useCallback(async (unique_id, order, action) => {
    if (await showQRCodeDialog(unique_id, order)) {
      handleGetList(true, action.status);
    } else {
      handleGetList(true, action.status);
    }
  }, []);

  const handleGetList = (refresh, actionStatus) => {
    let status = actionStatus
      ? actionStatus
      : tabActive
      ? arrTabs[tabActive]["status"]
      : "new";

      setStatus(status);

    let runner_request = status === "new" ? true : "";
    let runner_picked = status === "complete" ? true : false;

    var params = {
      num: !perPage ? "" : perPage.toString(),
      cursor: !perPage
        ? ""
        : refresh === false && tabActive === prevTabActive
        ? orderState.header["x-cursor"]
        : "",
      sort_by: "tenant",
      property_id: user?.operational?.id || "",
      progress: "process",
      runner_request: runner_request,
      runner_picked: runner_picked,
      keyword: search,
    };
    orderActions.getList(
      params,
      refresh === false && tabActive === prevTabActive ? true : false,
      status
    );
  };

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      handleGetList(true);
    }, 500);

    return () => clearTimeout(timeout);
  }, [tabActive, search]);

  return (
    <BaseLayout>
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <h3>Runner</h3>
        </Grid>
        {/* <Grid
          container
          item
          xs={12}
          direction="row"
          alignItems="flex-end"
          justify="flex-start"
        >
          <InputSearch
            value={search}
            onChange={(e) => {
              handleSearch(e);
            }}
            placeholder="Search"
          />
        </Grid> */}
      </Grid>
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <StyledPaperTabs square>
            <StyledTabs
              value={tabActive}
              onChange={handleChangeTab}
              scrollButtons="auto"
              aria-label="Voucher tab"
            >
              {arrTabs.map((row, key) => {
                return <StyledTab key={key} label={row.label} />;
              })}
            </StyledTabs>
          </StyledPaperTabs>
          <TableContainer>
            <StyledTable>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCellBodyBold align="left" width="5%">
                    No
                  </StyledTableCellBodyBold>
                  <StyledTableCellBodyBold align="left" width="25%">
                    Tenant
                  </StyledTableCellBodyBold>
                  <StyledTableCellBodyBold align="left" width="15%">
                    Point Location
                  </StyledTableCellBodyBold>
                  <StyledTableCellBodyBold align="left" width="20%">
                    Customer
                  </StyledTableCellBodyBold>
                  <StyledTableCellBodyBold align="left" width="25%">
                    Order Time
                  </StyledTableCellBodyBold>
                  <StyledTableCellBodyBold
                    align="right"
                    width="10%"
                  ></StyledTableCellBodyBold>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {orderState.data.length > 0 &&
                  !orderState.refresh &&
                  orderState.data.map((transaction, key) => {
                    return (
                      <ListOrder
                        handleShowQR={handleShowQR}
                        handleUpdateRunner={handleUpdateRunner}
                        no={key + 1}
                        key={transaction.orders[0].id}
                        transaction={transaction}
                        order={transaction.orders[0]}
                        action={tabActive ? arrTabs[tabActive] : arrTabs[0]}
                        access={access}
                      />
                    );
                  })}

                {orderState.isLoading &&
                  Array.from(new Array(5)).map((value, key) => {
                    return <ListLoadingOrder key={key} />;
                  })}
              </TableBody>
            </StyledTable>
          </TableContainer>
        </Grid>
        {!orderState.isLoading && orderState.data.length === 0 && (
          <Grid item xs={12}>
            <div className={classes.demo1}>
              <Grid
                item
                xs
                container
                justify="center"
                style={{ margin: 10, padding: 12 }}
              >
                <span>No Data</span>
              </Grid>
            </div>
          </Grid>
        )}
      </Grid>
    </BaseLayout>
  );
};

export default Runner;
